import React, { Component, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import { ROUTES } from "./routeList";
// import TitleMapper from "./titleMapper";
import { uuidv4 } from "../utils";
import Loader from "../common/loader/loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ESERVICE_URL } from "../utils/constants";

class Routes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sessionLoading: false,
      sessionId: localStorage.getItem("formSessionId") || null,
      currentStep: 0,
      formData: {
        moveInDate: "",
        servicesRequested: [],
        adwordsTracking: {}
      }
    };
    this.trackingCaptured = false; // Flag to prevent multiple captures
  }
  parseQueryParams = (query = "") => {
    try {
      if (query) {
        const queryParams = query.replace("?", "");
        const params = queryParams.split("&");
        const paramsObject = params.reduce((acc, param) => {
          const splitParam = param.split("=");
          const key = splitParam.shift();
          return {
            ...acc,
            [key]: splitParam.join("=")
          };
        }, {});

        return paramsObject;
      }

      return false;
    } catch (e) {
      console.error(e);
    }

    return false;
  };

  componentWillMount() {
    // Capture Google Ads params: campaignid, adgroupid, keyword, device, gclid
    // Capture UTM params: utm_source, utm_medium, utm_campaign, utm_content, utm_term

    // Prevent multiple captures in the same session
    if (this.trackingCaptured) {
      console.log("📊 Tracking already captured this session, skipping");
      return false;
    }

    try {
      console.log(
        "📊 Routes componentWillMount - URL search:",
        window.location.search
      );
      const queryParams = this.parseQueryParams(window.location.search);
      console.log("📊 Parsed query params:", queryParams);

      if (!queryParams) {
        console.log("📊 No query params found");
        return false;
      }

      const {
        adgroupid,
        campaignid,
        device,
        keyword,
        gclid,
        utm_source,
        utm_medium,
        utm_campaign,
        utm_content,
        utm_term
      } = queryParams;

      // Check if any tracking parameter exists
      const hasTrackingParams =
        adgroupid ||
        campaignid ||
        device ||
        keyword ||
        gclid ||
        utm_source ||
        utm_medium ||
        utm_campaign ||
        utm_content ||
        utm_term;

      if (!hasTrackingParams) {
        console.log("📊 No tracking params in query");
        return false;
      }

      console.log("📊 Found tracking params:", {
        adgroupid,
        campaignid,
        device,
        keyword,
        gclid,
        utm_source,
        utm_medium,
        utm_campaign,
        utm_content,
        utm_term
      });

      const gawRaw = localStorage.getItem("gaw");
      let gaw = gawRaw ? JSON.parse(gawRaw) : [];

      const trackingEntry = {
        // Google Ads parameters
        adgroupid,
        campaignid,
        device,
        keyword,
        gclid,
        // UTM parameters
        utm_source,
        utm_medium,
        utm_campaign,
        utm_content,
        utm_term,
        // Metadata
        timestamp: Date.now(),
        landing_page: window.location.pathname
      };

      // Check if this exact tracking entry already exists (excluding timestamp and landing_page)
      const isDuplicate =
        Array.isArray(gaw) &&
        gaw.some(
          entry =>
            entry.campaignid === trackingEntry.campaignid &&
            entry.adgroupid === trackingEntry.adgroupid &&
            entry.gclid === trackingEntry.gclid &&
            entry.keyword === trackingEntry.keyword &&
            entry.device === trackingEntry.device &&
            entry.utm_source === trackingEntry.utm_source &&
            entry.utm_medium === trackingEntry.utm_medium &&
            entry.utm_campaign === trackingEntry.utm_campaign
        );

      if (isDuplicate) {
        console.log("📊 Duplicate tracking entry detected, skipping");
        this.trackingCaptured = true; // Mark as captured even for duplicates
        return false;
      }

      if (Array.isArray(gaw)) {
        gaw.push(trackingEntry);
      } else {
        gaw = [trackingEntry];
      }
      localStorage.setItem("gaw", JSON.stringify(gaw));
      console.log("📊 Saved gaw to localStorage:", gaw);
      this.trackingCaptured = true; // Mark as captured after successful save
    } catch (e) {
      console.error("📊 Error in tracking capture:", e);
    }
  }

  componentDidMount() {
    this.createSession();
  }

  createSession = async () => {
    try {
      this.setState({ sessionLoading: true });

      if (this.state.sessionId) {
        const response = await fetch(
          `${ESERVICE_URL}v2/multi-form/session/${this.state.sessionId}`
        );

        if (response.ok) {
          // const sessionData = await response.json();
          // this.setState({
          //   currentStep: sessionData.currentStep,
          //   formData: {
          //     ...this.state.formData,
          //     ...sessionData.data,
          //     moveInDate: sessionData.data.moveInDate
          //       ? this.formatDateForInput(sessionData.data.moveInDate)
          //       : "",
          //     servicesRequested: sessionData.data.servicesRequested || [],
          //     adwordsTracking:
          //       sessionData.data.adwordsTracking || this.state.formData.adwordsTracking
          //   }
          // });
          return;
        }
        // Handle 404/410 cases
      }

      const response = await fetch(
        `${ESERVICE_URL}v2/multi-form/session/start`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" }
        }
      );

      if (response.ok) {
        const data = await response.json();
        this.setState({ sessionId: data.sessionId });
        localStorage.setItem("formSessionId", data.sessionId);
      }
    } catch (error) {
      console.error("Error creating session:", error);
      //  this.createSession();
    } finally {
      this.setState({ sessionLoading: false });
    }
  };

  shouldComponentUpdate() {
    return true;
  }

  render() {
    const toastOptions = {
      position: "top-right",
      autoClose: 4000,
      hideProgressBar: false,
      newestOnTop: false,
      closeOnClick: true,
      rtl: false,
      pauseOnFocusLoss: true,
      draggable: true,
      pauseOnHover: true
    };
    return (
      <div>
        {/* <Route component={TitleMapper} /> */}
        <Suspense fallback={<Loader />}>
          <ToastContainer {...toastOptions} />
          <Switch>
            {ROUTES.map(({ path, component, title }) => {
              window.title = title;
              return (
                <Route key={uuidv4()} exact path={path} component={component} />
              );
            })}
          </Switch>
        </Suspense>
      </div>
    );
  }
}

export default Routes;
